import clsx from "clsx";
import React from "react";
export default function ImageCheckboxGrid({ items, current, onToggle, }) {
    return (<div className="grid grid-cols-3 gap-2">
      {items.map((item) => {
            const checked = current.includes(item.value);
            const disabled = item.disabled || !item.available;
            return (<button key={item.value} type="button" onClick={() => !disabled && onToggle(item.value)} disabled={disabled} className={clsx("flex flex-col items-center justify-between rounded-xl border p-2 gap-1 text-center cursor-pointer", checked
                    ? "border-black bg-gray-100"
                    : "border-[#A1A2A5] bg-white", disabled ? "opacity-40 cursor-not-allowed" : "")}>
            <div className="w-full flex items-center justify-center h-10">
              {item.img && (<img src={item.img} alt={item.label} className="max-h-full w-full max-w-full object-contain"/>)}
            </div>
            <span className="text-xs leading-tight">{item.label}</span>
          </button>);
        })}
    </div>);
}
